<template lang="pug" functional>
  .v-card__content
    slot
</template>

<script>
export default {
  name: 'VCardContent'
}
</script>

<style lang="scss" scoped>
</style>
